import axios from 'axios';
axios.defaults.baseURL = 'https://neos.crellutions.at/api';
axios.defaults.withCredentials = false;

let http = {
    loadImages(type, refId) {
        console.log(`api loading ${type} mit id: ${refId}`)
        return axios.get(`/image/${type}/` + refId)
            .then(response=>{
//                console.log('Loading Images');
//                console.log(response);
                return response.data
            });
    },
    loadImageRAW(type, refId) {
        return axios.get(`/image/${type}/` + refId)
    },
    get(...parameter){
        return axios.get(...parameter)
    },
    patch(...parameter){
        return axios.patch(...parameter)
    },
}

export default http
